import { render, staticRenderFns } from "./StakeAllocationBlock.vue?vue&type=template&id=18ec0a61&"
import script from "./StakeAllocationBlock.vue?vue&type=script&lang=js&"
export * from "./StakeAllocationBlock.vue?vue&type=script&lang=js&"
import style0 from "./StakeAllocationBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports